import { HStack, Box } from "@chakra-ui/react";
import { StarIcon } from "@chakra-ui/icons";

export function StarDisplay({ rating = 4.5, size = 4 }) {
  return (
    <HStack spacing={1} display="inline-flex">
      {[...Array(5)].map((_, i) => {
        const starNumber = i + 1;
        const isFull = rating >= starNumber;
        const isHalf = rating > i && rating < starNumber;

        return (
          <Box
            key={i}
            position="relative"
            display="flex" // Ensures no weird text-descender spacing
            alignItems="center"
            justifyContent="center"
            boxSize={size} // Force the container to match the icon size
          >
            {/* 1. Background (Empty Star) */}
            <StarIcon boxSize={size} color="gray.200" />

            {/* 2. Foreground (Filled Star) */}
            {(isFull || isHalf) && (
              <StarIcon
                boxSize={size}
                color="warning.500"
                position="absolute"
                // Pinning strictly to the top-left of the flex container
                top="0"
                left="0"
                zIndex={1}
                clipPath={isHalf ? `inset(0 50% 0 0)` : "none"}
              />
            )}
          </Box>
        );
      })}
    </HStack>
  );
}
